import {
  MODAL_STATE_FLAG_PREFIX,
  MODAL_STATE_FLAG_SUFFIX,
} from './modalConstants';

function getModalStateFlagName(modalId) {
  return MODAL_STATE_FLAG_PREFIX + modalId + MODAL_STATE_FLAG_SUFFIX;
}

export {
  getModalStateFlagName,
};
